import React, { useEffect, useState } from "react";

const OptionItem = (props) => {
    const {
        isSelected,
        value,
        data,
        text,
        onOptionSelected,
        widthPercent,
        attributes,
    } = props;
    const css = `border rounded-md px-6 py-5 grow text-center cursor-pointer ${
        isSelected
            ? "border-skin-primary text-skin-primary bg-skin-primary-light"
            : "border-skin-divider"
    }`;

    const style = {
        width: widthPercent ? `${widthPercent}%` : null,
    };

    const handleClick = (e) => {
        e.preventDefault();
        onOptionSelected({
            value: value,
            data: data,
        });
    };

    return (
        <div
            className={css}
            style={style}
            onClick={handleClick}
            {...attributes}
        >
            {text}
        </div>
    );
};

const OptionsBox = ({ data, onOptionSelected }) => {

    const { options } = data;
    if (!options) return;
    const [value, setValue] = useState(options.find((opt) => opt.isSelected));

    const handleOptionSelected = (value) => {
        setValue(value);
        onOptionSelected && onOptionSelected(value);
    };

    useEffect(() => {
        const isDataEmpty = data.value === null || data.value === undefined;

        if (isDataEmpty) return;

        var selectedOption = options.find((opt) => opt.value === data.value);

        if (!selectedOption) return;

        setValue(selectedOption);
        onOptionSelected && onOptionSelected(selectedOption);
    }, [data.value]);

    return (
        <div>
            {data.label && (
                <div className="flex items-center mb-2">
                    <label>{data.label}</label>
                </div>
            )}
            <div className="flex gap-4 align-center text-sm">
                {options.map((opt) => {
                    return (
                        <OptionItem
                            key={opt.value}
                            {...opt}
                            isSelected={value && value.value === opt.value}
                            onOptionSelected={handleOptionSelected}
                            attributes={opt.attributes ?? {}}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default OptionsBox;
